/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import {
  EuiComboBox,
  EuiComboBoxOptionOption,
  EuiComboBoxProps,
  EuiPopover,
} from "@inscopix/ideas-eui";
import { useState } from "react";

export interface MultiStringEditorProps {
  onValueChange: (newValue: string[]) => void;
  initialValue: string[];
  onClose: (cancel?: boolean) => void;
}

export const MultiStringEditor = ({
  initialValue,
  onValueChange,
  onClose,
}: MultiStringEditorProps) => {
  const [values, setValues] = useState<EuiComboBoxOptionOption<string>[]>(
    initialValue.map((val) => ({ label: val })),
  );

  const [searchValue, setSearchValue] = useState("");

  const onChange: EuiComboBoxProps<string>["onChange"] = (options) => {
    setValues(options.map((o) => ({ label: o.label })));
    onValueChange(options.map((o) => o.label));
  };

  const onCreateOption: EuiComboBoxProps<string>["onCreateOption"] = (
    searchValue,
    options,
  ) => {
    const newOptions = [...options, { label: searchValue }];
    onChange(newOptions);
  };

  return (
    <EuiPopover
      css={{ width: "100%", height: "100%" }}
      closePopover={onClose}
      isOpen={true}
      anchorPosition="downCenter"
    >
      <EuiComboBox
        css={css`
          min-width: 275px;
        `}
        onKeyDownCapture={(e) => {
          // handle enter on empty search as stop editing
          if (e.key === "Enter" && searchValue === "") {
            onClose();
          }
          if (e.key === "Escape") {
            e.preventDefault();
            onClose(true);
          }
        }}
        inputMode="text"
        placeholder="Type and hit enter to create option"
        options={values}
        selectedOptions={values.map(({ label }) => ({ label: label }))}
        onChange={onChange}
        onCreateOption={onCreateOption}
        onSearchChange={(searchValue) => setSearchValue(searchValue)}
        isClearable={false}
        noSuggestions
        autoFocus
      />
    </EuiPopover>
  );
};
